export default __webpack_public_path__ + "static/media/sanity.cbb8797c.svg";